import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#F20316', // #E53935
        secondary: '#DADEE6',
        accent: '#3F51B5'
      },
    },
  }
});
